import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import dayjs, { Dayjs } from 'dayjs';

type Props = {
  onChange: (date: Date | null) => void; // onChange deve receber um Date ou null
  disabled: boolean;
  label: string;
  readOnly: boolean;
  value?: Date | null; // O valor pode ser um Date ou undefined
};

export default function TextFieldData({ onChange, disabled, label, readOnly, value }: Props) {
  // Estado para armazenar a data selecionada como Dayjs
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(null);

  // Efeito para atualizar selectedDate quando o valor externo (value) muda
  React.useEffect(() => {
    if (value) {
      setSelectedDate(dayjs(value)); // Converte o valor de Date para Dayjs
    } else {
      setSelectedDate(null); // Se não houver valor, seleciona null
    }
  }, [value]);

  // Função para lidar com a mudança de data no componente DateField
  const handleDateChange = (date: Dayjs | null) => {
    setSelectedDate(date); // Atualiza o estado local com a nova data Dayjs
    if (date) {
      onChange(date.toDate()); // Converte Dayjs para Date e chama onChange
    } else {
      onChange(null); // Se date for null, chama onChange com null
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateField
        label={label}
        disabled={disabled}
        readOnly={readOnly}
        value={selectedDate}
        onChange={handleDateChange}
        format="DD/MM/YYYY"
        size="small"
      />
    </LocalizationProvider>
  );
}
